/**
 * Constant values for Common
 */
/**
 * Keydown event trigger
 * @hidden
 */
export var KEY_DOWN = 'keydown';
/**
 * Undo and Redo action HTML plugin events
 * @hidden
 */
export var ACTION = 'action';
/**
 * Formats plugin events
 * @hidden
 */
export var FORMAT_TYPE = 'format-type';
/**
 * Keydown handler event trigger
 * @hidden
 */
export var KEY_DOWN_HANDLER = 'keydown-handler';
/**
 * List plugin events
 * @hidden
 */
export var LIST_TYPE = 'list-type';
/**
 * Keyup handler event trigger
 * @hidden
 */
export var KEY_UP_HANDLER = 'keyup-handler';
/**
 * Keyup event trigger
 * @hidden
 */
export var KEY_UP = 'keyup';
/**
 * Model changed plugin event trigger
 * @hidden
 */
export var MODEL_CHANGED_PLUGIN = 'model_changed_plugin';
/**
 * Model changed event trigger
 * @hidden
 */
export var MODEL_CHANGED = 'model_changed';
/**
 * PasteCleanup plugin for MSWord content
 * @hidden
 */
export var MS_WORD_CLEANUP_PLUGIN = 'ms_word_cleanup_plugin';
/**
 * PasteCleanup for MSWord content
 * @hidden
 */
export var MS_WORD_CLEANUP = 'ms_word_cleanup';
